var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.paymentProviderType)?_c(_vm.paymentProviderComponent,_vm._g({ref:"payComponent",tag:"component",attrs:{"location":_vm.location,"payment-provider-public-options":_vm.paymentProviderPublicOptions}},_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }